// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"332":"afe1b189","336":"9d7dbf7d","404":"935c5128","706":"4cb73a2f","772":"01700ed0","773":"af5157ac","892":"2830a4c4"}[chunkId] + ".chunk.css";
};